export default {
  methods: {
    cardAsset(card) {
      return this.$store.getters[card.getter][card.assetId];
    },
    cardAssetCompleted(card) {
      const asset = this.cardAsset(card);
      const state = this.cardAssetState(card);
      if (asset && state) {
        return asset.completedState(state, this.$store);
      }
    },
    cardAssetInProgress(card) {
      const state = this.cardAssetState(card);
      if (state) {
        if (card.singular) {
          return true;
        } else if (card.container) {
          const asset = this.cardAsset(card);
          return asset.inProgressState(state, this.$store);
        }
      }
    },
    cardAssetState(card) {
      const asset = this.cardAsset(card);
      if (asset) {
        if (card.singular) {
          return asset.state?.(this.$store);
        } else if (card.container) {
          return asset.states(this.$store);
        }
      }
    },
    cardModalTitle(card) {
      return card?.title;
    },
    continueSeries() {
      let nextCard = '';
      for (const card of this.cards) {
        const asset = this.cardAsset(card);
        let state;
        if (!asset || asset.assetType === 'Deck') {
          return;
        }
        if (asset.assetType === 'Grouping') {
          state = asset.states(this.$store);
        } else {
          state = asset.state(this.$store);
        }
        if (!asset.completedState(state)) {
          nextCard = card;
          break;
        }
      }
      this.goToCard(nextCard);
    },
    featuredImage(card) {
      if (card) {
        return this.$store.getters['attachments/get'][card.featuredImageId];
      }
    },
    isCardLocked(card) {
      const assetType = card.assetType;
      if (assetType !== 'Category') {
        return false;
      } else {
        return !this.$access(this.$store, assetType.toLowerCase(), card.assetId);
      }
    },
    metadata(card) {
      const asset = this.cardAsset(card);
      return asset?.cardMetadata?.(this.$store);
    },
    metadataIconName(card) {
      if (card.isAttachmentCard || card.isGroupingCard || card.isTopicCard) {
        return this.cardAsset(card)?.icon;
      }
      return card.icon;
    },
    navigationItemQuery(card) {
      const navId = card?.navigationItemId;
      if (!navId) {
        return '';
      }

      const navigationItem = this.$store.getters['navigationItems/navigationItems'][navId];
      if (navigationItem) {
        return navigationItem.query;
      }
      return '';
    },
    openCard(card, parentDeck) {
      if (this.isCardLocked(card) && card.isTestSimulationCard) {
        this.$store.dispatch('ui/toggleUpsellModal', { show: true });
        return;
      }
      let route;
      if (card.isTopicCard || card.isAttachmentCard) {
        route = card.route;
        if (parentDeck) {
          route.params.deckId = parentDeck.id;
        }
      } else if (card.isDeckCard) {
        route = card.route;
        if (parentDeck) {
          route.params.parentDeckId = parentDeck.id;
        }
      } else if (card.isGroupingCard) {
        const grouping = this.$store.getters['groupings/all'][card.assetId];
        route = grouping?.route;
      } else {
        route = card.route;
      }
      if (route) {
        const navId = parseInt(route?.query?.nav);
        if (typeof navId === 'number' && !isNaN(navId)) {
          route.query.nav = this.navigationItemQuery(card);
        } else if (this.currentQuery) {
          route.query = this.currentQuery;
        }
        this.$router.push(route);
      }
    },
    restartSeries() {
      this.$store.dispatch('decks/resetDeckStates', this.deck).then(() => this.beginSeries());
    },
  },
};
